/**
 * Image Hotspot Cards — opens Spinnio only from [data-ihc-spinnio-open] on the spin card.
 */
(function initImageHotspotCardsSpinnio() {
  const SPINNIO_OPEN_SELECTOR = '[data-ihc-spinnio-open]';
  const PROMO_CTA_SELECTOR = '.image-hotspot-cards__promo-cta';
  const RULES_OPEN_SELECTOR = '[data-ihc-rules-open]';
  const RULES_CLOSE_SELECTOR = '[data-ihc-rules-close]';
  const OPEN_RETRY_MS = 100;
  const OPEN_TIMEOUT_MS = 5000;

  /**
   * @returns {Promise<boolean>}
   */
  async function openSpinnio() {
    const startedAt = Date.now();

    while (Date.now() - startedAt < OPEN_TIMEOUT_MS) {
      const spinnio = window.Spinnio;
      if (spinnio && typeof spinnio.open === 'function') {
        spinnio.open();
        return true;
      }

      await new Promise((resolve) => {
        window.setTimeout(resolve, OPEN_RETRY_MS);
      });
    }

    console.warn('[image-hotspot-cards] window.Spinnio.open is not available');
    return false;
  }

  /**
   * @param {Document|Element} root
   */
  function bindSpinnioTriggers(root) {
    root.querySelectorAll(SPINNIO_OPEN_SELECTOR).forEach((button) => {
      if (button.dataset.ihcSpinnioBound === '1') {
        return;
      }
      button.dataset.ihcSpinnioBound = '1';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        void openSpinnio();
      });
    });
  }

  /**
   * Stop legacy document-level handlers that match spin-button--primary on promo CTAs.
   *
   * @param {Document|Element} root
   */
  function bindPromoCtaNavigation(root) {
    root.querySelectorAll(PROMO_CTA_SELECTOR).forEach((link) => {
      if (link.dataset.ihcPromoNavBound === '1') {
        return;
      }
      link.dataset.ihcPromoNavBound = '1';
      link.addEventListener(
        'click',
        (event) => {
          event.stopPropagation();
        },
        false
      );
    });
  }

  /**
   * @param {Document|Element} root
   */
  function bindRulesDialogs(root) {
    root.querySelectorAll(RULES_OPEN_SELECTOR).forEach((rulesOpenButton) => {
      if (rulesOpenButton.dataset.ihcRulesOpenBound === '1') {
        return;
      }
      rulesOpenButton.dataset.ihcRulesOpenBound = '1';
      rulesOpenButton.addEventListener('click', (event) => {
        event.stopPropagation();
        const dialog = rulesOpenButton
          .closest('.image-hotspot-cards__spin-card')
          ?.querySelector('[data-ihc-rules-dialog]');
        if (dialog instanceof HTMLDialogElement) {
          dialog.showModal();
        }
      });
    });

    root.querySelectorAll(RULES_CLOSE_SELECTOR).forEach((rulesCloseButton) => {
      if (rulesCloseButton.dataset.ihcRulesCloseBound === '1') {
        return;
      }
      rulesCloseButton.dataset.ihcRulesCloseBound = '1';
      rulesCloseButton.addEventListener('click', (event) => {
        event.stopPropagation();
        const dialog = rulesCloseButton.closest('[data-ihc-rules-dialog]');
        if (dialog instanceof HTMLDialogElement) {
          dialog.close();
        }
      });
    });
  }

  /**
   * @param {Document|Element} root
   */
  function bindSection(root) {
    bindSpinnioTriggers(root);
    bindPromoCtaNavigation(root);
    bindRulesDialogs(root);
  }

  bindSection(document);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) {
      bindSection(event.target);
    }
  });
})();
